import { createContext } from 'react';
const defaultStyles = {
  topLevelBoxStyle: {},
  contentFlexStyle: {},
  inputStyle: {},
  recordingIndicatorStyle: {}
};
export const StyleContext = createContext(defaultStyles);